<template>
  <div class="vx-col w-full mb-5" >
    <h6 class="mb-6">{{f.indication}}</h6>

    <template v-if="!hasBackofficeAccess">
      <vs-alert v-if="pendingVerificationRequest && pfg_locations.length > 0" icon-pack="feather" icon="icon-alert-triangle" class="mt-4 mb-base" color="dark">
          <span class="font-regular">La sección se encuentra en proceso de ser completada.
          Cuando consideres la información y documentos cargados son los adecuados en todas las ubicaciones, da click en el botón <strong>"Solicitar validación de evidencias"</strong> para enviarla a revisión.</span>
      </vs-alert>

      <div v-if="pendingVerificationRequest && pfg_locations.length > 0" class="vx-col w-full mt-4 mb-base flex" id="account-manage-buttons">
        <vs-button class="mr-4" @click="requestAccreditation">Solicitar validación de evidencias</vs-button>
      </div>

      <vs-alert v-if="!pendingVerificationRequest && !evidencesVerified" icon-pack="feather" icon="icon-alert-circle" style="height:auto" class="mt-4 mb-base" color="warning">
        <span class="font-regular">Se ha solicitado la revisión de las evidencias. En breve se te dará respuesta.</span>
      </vs-alert>

      <vs-alert v-if="evidencesVerified" icon-pack="feather" icon="icon-check-circle" style="height:auto" class="mt-4 mb-base" color="success">
        <span class="font-regular">Las evidencias ha sido verificadas.</span>
      </vs-alert>
    </template>

    <template v-else>
      <vs-alert v-if="pendingVerificationRequest && pfg_locations.length > 0" icon-pack="feather" icon="icon-alert-triangle" class="mt-4 mb-base" color="dark">
        <span class="font-regular">La sección se encuentra en proceso de ser completada.</span>
      </vs-alert>
      <vs-alert v-if="!pendingVerificationRequest && !evidencesVerified" icon-pack="feather" icon="icon-alert-circle" style="height:auto" class="mt-4 mb-base" color="warning">
        <span class="font-regular">Se ha solicitado la revisión de las evidencias.</span>
      </vs-alert>
      <vs-alert v-if="evidencesVerified" icon-pack="feather" icon="icon-check-circle" style="height:auto" class="mt-4 mb-base" color="success">
        <span class="font-regular">Las evidencias ha sido verificadas.</span>
      </vs-alert>
    </template>

    <vs-table stripe :data="pfg_locations" noDataText="No se han generado registros">
      <template slot="thead">
        <vs-th class="bold">UBICACIÓN</vs-th>
        <vs-th class="bold">SISTEMA O TECNOLOGÍA</vs-th>
        <vs-th class="bold">ACCIONES</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">

          <vs-td :data="data[indextr].id">
            {{ addressForLocation(data[indextr]) }}
          </vs-td>

          <vs-td :data="data[indextr].family_group_id">
            {{ uppercase(data[indextr].family_group.name) }}
          </vs-td>

          <vs-td :data="data[indextr].id">
            <feather-icon v-if="!hasBackofficeAccess && !isDisabled" icon="EditIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current cursor-pointer" @click.stop="showItemRequest(data[indextr])" />
            <feather-icon v-if="hasBackofficeAccess || isDisabled" icon="EyeIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current cursor-pointer" @click.stop="showItemRequest(data[indextr])" />
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <vx-card title="Información de evidencias concentrada">
      <vs-collapse accordion>
        <vs-collapse-item :key="index" v-for="(item, index) in pfg_locations">
          <div slot="header">
            Tecnología: <strong>{{uppercase(item.family_group.name)}}</strong> | {{addressForLocation(item)}} 
          </div>
          <project-technology-evidences-page :id="item.project_id" :fg_id="item.id"></project-technology-evidences-page>
        </vs-collapse-item>
      </vs-collapse>
    </vx-card>

  </div>

</template>

<script>
import inputHelper from "@mixins/inputHelper";
import ProjectTechnologyEvidencesPage from "@views/admin/projectsv2/ProjectTechnologyEvidencesPage";

export default {
  name: 'technology-location-evidences-control',
  mixins: [inputHelper],
  props: {
    project_id: {type: [String, Number], required: true},
    f: { type: Object, required: true },
    isDisabled: { type: [String,Boolean], default: false },
  },
  components: {
    ProjectTechnologyEvidencesPage
  },
  data(){
    return {
      pfg_locations: [],

      showFormPrompt: false,
      selectedTechnology: null,
      project: {},
    }
  },
  beforeMount: async function(){
    await this.loadSavedProjectFgLocations();
  },
  computed: {
    pendingVerificationRequest(){
      return this.project.evidence_verification_request_date == null
    },
    evidencesVerified(){
      return this.project.complete_evidence_date != null
    },
    hasBackofficeAccess(){
      return this.$acl.check('isBackoffice');
    },
  },
  methods: {
    addressForLocation(pfg_location){
      if(pfg_location.location && pfg_location.location.address){
        let addr = pfg_location.location.address.full_address;
        if(addr.length > 60){
          return addr.substring(0, 60) + "...";
        }
        else {
          return addr;
        }
      }
      else{
        return "Sin definir";
      }
    },
    async loadSavedProjectFgLocations(){
      try {
        let res = await axios.get(`/api/v1/project/${this.project_id}/getProjectFgLocations`);
        this.pfg_locations = res.data;

        let res2 = await axios.get(`/api/v2/projects/${this.project_id}/`);
        this.project = res2.data;
      }
      catch (e) {
        this.warn(e);
      }
    },
    showItemRequest(pfg_location){
      // this.$router.push({ name: 'evidenciasFgLocationProyecto', params: { id: this.project_id, fg_id: pfg_location.id } })
      let routeData = this.$router.resolve({name: 'evidenciasFgLocationProyecto', params: { id: this.project_id, fg_id: pfg_location.id }});
      window.open(routeData.href, '_blank');
    },

    async requestAccreditation(){
      let ok  = await this.checkForValidAccreditation();

      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: 'Solicitar acreditación de tecnología',
        text: `¿Estás seguro que deseas enviar tu solicitud a revisión? La solicitud será atendida en breve.`,
        acceptText: "Enviar solicitud",
        cancelText: 'Cancelar',
        accept: this.doRequestAccreditation
      });
    },

    async doRequestAccreditation(){
      this.showLoading(true);
      try {
        await axios.post(`/api/v1/project/${this.project_id}/requestProjectEvidencesVerification`, {});
        await this.loadSavedProjectFgLocations();
      } catch (error) {
        this.warn(error);
        this.failedOperationNotif(null, null);
      }
      this.showLoading(false);
    },
    async checkForValidAccreditation(){
      // comprobar que se cumplan todos los requerimientos
      return false;
    },

    /* check validation */
    validate(){
      return this.technologies.length >= 3;
    }
  }
}
</script>